module.exports = __webpack_public_path__ + "static/img/case_detail_03_1.74ef005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_03_1.png
// module id = nhIZ
// module chunks = 34